<template>
    <div class="regional-sales-manager-container">
        <div class="row">
            <div class="col-lg-12 stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Regional Sales Manager Maintenance</h4>
                        <div class="filters">
                            <div class="row mb-3">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col">
                                            <label>Regional Sales Manager Code:</label>
                                            <input type="text" class="form-control" placeholder="RSM Code"
                                                v-model="filter.rsmCode" :disabled="isSearching" />
                                        </div>
                                        <div class="col">
                                            <p style="margin-bottom: 0.3rem">&nbsp;</p>
                                            <button type="button" class="btn btn-primary" @click="searchFilter"
                                                :disabled="isSearching">
                                                <i class="fas fa-search"></i>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-right">
                                    <p style="margin-bottom: 0rem">&nbsp;</p>
                                    <button type="button"
                                        class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                                        :disabled="isSearching" @click="addNewRSM">
                                        <i class="fas fa-user-plus"></i>
                                        Add Regional Sales Manager
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>RSM Code</th>
                                        <th>RSM Name</th>
                                        <th>Agents</th>
                                        <th>Email/s</th>
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="regionalSalesPageItems.length == 0 && !isSearching">
                                        <td colspan="10">
                                            <div>
                                                <lottie-animation style="height: 500px" :loop="true" :animationData="require('@/assets/lottie/no-data.json')" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="isSearching">
                                        <td colspan="10">
                                            <div class="text-center">
                                                <i class="fas fa-spinner fa-spin mr-1" />
                                                <span>Loading. . .</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="(rsm, i) in regionalSalesPageItems" :key="i">
                                        <td>{{ rsm.rsmCode }}</td>
                                        <td>{{ rsm.rsmName }}</td>
                                        <td>
                                            <a href="#" @click="selectRSMAgent(rsm)">
                                                Agents
                                            </a>
                                        </td>
                                        <td>{{ rsm.listEmail.toString() }}</td>
                                        <td class="text-center">
                                            <a href="#" @click="showUserAccess(rsm.rsmCode)">
                                                Users
                                            </a>
                                            |
                                            <a href="#" @click="selectRSM(rsm)"> Edit </a>
                                            |
                                            <a href="#" @click="deleteRSM(rsm)">Delete</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <b-pagination v-if="regionalSalesPageItems.length != 0" v-model="currentPage" :total-rows="rows"
                            :per-page="pageSize" aria-controls="my-table" @change="paginationChanged"
                            style="float: right; margin-top: 20px"></b-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for Selected RSM and its Agent Codes -->
        <b-modal v-model="rsmAgentsModalShow" size="md" title="RSM Agents" hide-footer no-close-on-backdrop>
            <p>
                RSM Code: <b>{{ rsmCode }}</b>
            </p>
            <hr />
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Agent Code</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="rsmAgents.length == 0">
                        <td colspan="1">
                            <div>
                                <lottie-animation style="height: 500px" :loop="true"
                                    :animationData="require('@/assets/lottie/no-data.json')" />
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(agent, i) in rsmAgents" :key="i">
                        <td>{{ agent }}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>

        <!-- Modal for RSM Details -->
        <b-modal v-model="rsmModalShow" size="xl" title="RSM Details" hide-footer no-close-on-backdrop>
            <form class="forms-sample">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="txtRSMCode" ref="modalRSMDetails"> RSM Code </label>
                            <input type="text" class="form-control" id="txtRSMCode" placeholder="RSM Code"
                                :class="{ 'is-invalid': $v.regionalSalesManager.rsmCode.$error, }"
                                v-model="$v.regionalSalesManager.rsmCode.$model" :disabled="isEdit" />
                            <div class="form-error" v-if="$v.regionalSalesManager.rsmCode.$error">
                                RSM Code is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="txtEmails">Agent Codes</label>
                            <multiselect v-model="listAgentCodes" placeholder="Add Agent code/s" label="name" track-by="code"
                                :class="{ 'is-invalid': $v.regionalSalesManager.listAgentCodes.$error }"
                                :options="agentOptions" :multiple="true" no-options-text="No Agent available">
                            </multiselect>
                            <div class="form-error" v-if="$v.regionalSalesManager.listAgentCodes.$error">
                                Agent Code is required.    
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="txtRSMName" ref="modalRSMDetails"> RSM Name </label>
                            <input type="text" class="form-control" id="txtRSMName" placeholder="RSM Name" :class="{
                                'is-invalid': $v.regionalSalesManager.rsmName.$error,
                            }" v-model="$v.regionalSalesManager.rsmName.$model" />
                            <div class="form-error" v-if="$v.regionalSalesManager.rsmName.$error">
                                RSM Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="txtEmails">Emails</label>
                            <multiselect v-model="listEmail" tag-placeholder="Add this email" placeholder="Add email"
                                label="name" track-by="code" :options="options" :multiple="true" :taggable="true"
                                @tag="addEmailTag" @remove="removeTag" :class="{
                                    'is-invalid': $v.regionalSalesManager.listEmail.$error,
                                }"></multiselect>
                            <div class="form-error" v-if="$v.regionalSalesManager.listEmail.$error">
                                Emails is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <button type="button" class="btn btn-primary mr-2" @click="submitRegionalSalesManager">
                            Submit
                        </button>
                        <button type="button" class="btn btn-outline-light" @click="closeModal">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>

        <!-- RSM User Access Sidebar -->
        <b-sidebar id="sidebar-backdrop" backdrop shadow right width="1000px" no-header-close v-model="showSidebar"
            @change="changeSidebarStatus">
            <div class="px-3 py-3">
                <div class="row">
                    <div class="col">
                        <h3><strong>RSM User Access</strong></h3>
                    </div>
                    <div class="col text-right">
                        <button type="button" class="btn btn-primary mr-2"
                            @click="openAddUserModal">
                            Add User
                        </button>
                    </div>
                </div>

                <hr style="opacity: 0.08" />
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Report Access</th>
                            <th>Date Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rsm, i) in lstRSMAccess" :key="i">
                            <td>{{ rsm.name }}</td>
                            <td>{{ rsm.email }}</td>
                            <td>
                                <p class="badge bg-primary mr-1" v-for="(access, x) in rsm.listReportAccess" :key="x"
                                    style="display: block; margin-bottom: 2px !important;">
                                    {{ reportAccessOption.filter(n => n.code == access)[0]?.name }} <br />
                                </p>
                            </td>
                            <td>
                                {{
                                    new Date(rsm.dateCreated).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: "numeric",
                                        year: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric',
                                    })
                                }}
                            </td>
                            <td>
                                <a href="#" @click="editRSMAccess(rsm);">
                                    Edit
                                </a>
                                |
                                <a href="#" @click="resetRSMAccess(rsm.email);">
                                    Reset
                                </a>
                                |
                                <a href="#" @click="deleteRSMAccess(rsm.email)">Delete</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-sidebar>

        <!-- Add/Edit RSM Access Modal -->
        <b-modal v-model="addRSMAccessModalShow" size="md" title="RSM Access" hide-footer no-close-on-backdrop>
            <form class="forms-sample">
                <div class="row">
                    <div class="col">
                        <p>
                            RSM Code:
                            <strong>{{ activeRsmCode }}</strong>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="txtFirstName">Name</label>
                            <input class="form-control" type="text" v-model="rsmAccess.name" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="txtFirstName">Email</label>
                            <input class="form-control" type="text" v-model="rsmAccess.email" :disabled="isEditAccess" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="txtFirstName">Report Access</label>
                            <multiselect v-model="listReportAccess" label="name" track-by="code" :options="reportAccessOption"
                                :multiple="true" />
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <button type="button" class="btn btn-primary mr-2" @click="AddRSMAccess">
                            Submit
                        </button>
                        <button type="button" class="btn btn-outline-light" @click="addRSMAccessModalShow = !addRSMAccessModalShow">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";
import { required } from "vuelidate/lib/validators";

export default {
    components: {
        LottieAnimation,
    },
    data() {
        return {
            addRSMAccessModalShow: false,
            showSidebar: false,
            activeRsmCode: '',
            file: null,
            regionalSalesPageItems: [],
            options: [],
            rsmModalShow: false,
            rsmAgentsModalShow: false,
            pageSize: 50,
            currentPage: 1,
            isSearching: false,
            isDownloading: false,
            isEdit: false,
            isEditAccess: false,
            listEmail: [],
            listAgentCodes: [],
            rsmCode: "",
            rsmAgents: [],
            reportAccessOption: [
                { code: "DMR", name: "Delivery Monitoring Report" },
                { code: "SSR", name: "Sales Summary Report" },
                { code: "ILR", name: "Invoice Listing Report" },
                { code: "SRR", name: "Sales Returns Report" },
                { code: "FFSOHR", name: "Field Force Stock on Hand Report" },
                { code: "DAR", name: "Detailed Aging Report" },
                { code: "PCR", name: "PDC Collection Report" },
                // { code: "IIR", name: "Inventory Level Report" },
                // { code: "COR", name: "Consignment Order Report" },
                // { code: "PSOR", name: "Pending Sales Order Report" },
                // { code: "PSOCSR", name: "Pending Sales Order CS Report" },
                // { code: "DAPR", name: "Detailed Aging by Principal Report" }
            ],
            listReportAccess: []
        };
    },
    validations: {
        regionalSalesManager: {
            rsmCode: {
                required,
            },
            rsmName: {
                required,
            },
            listAgentCodes: {
                required,
            },
            listEmail: {
                required,
            },
        },
    },
    computed: {
        ...mapState({
            regionalSales: (state) => state.regionalSalesController.regionalSales,
            filter: (state) => state.regionalSalesController.filter,
            regionalSalesManager: (state) => state.regionalSalesController.regionalSalesManager,
            agents: (state) => state.territoryController.territories,
            lstRSMAccess: (state) => state.regionalSalesController.lstRSMAccess,
            rsmAccess: (state) => state.regionalSalesController.rsmAccess,
        }),
        agentOptions() {
            return this.agents.filter(m => m.rsmCode == null).map((mg) => ({
                ["name"]: mg.agentCode,
                ["code"]: mg.agentCode + "-001",
            }));
        },
        rows() {
            return this.regionalSales.length;
        },
    },
    methods: {
        ...mapMutations({
            setRegionalSalesManager: "regionalSalesController/SET_RegionalSalesManager",
            resetRegionalSalesManager: "regionalSalesController/RESET_RegionalSalesManager",
        }),
        validateEmail: function (email) {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        openAddUserModal: function () {
            this.rsmAccess.name = '';
            this.rsmAccess.email = '';
            this.rsmAccess.reportAccess = '';
            this.rsmAccess.rsmCode = this.activeRsmCode;
            this.listReportAccess = [];
            this.isEditAccess = false;
            this.addRSMAccessModalShow = true;
        },
        showUserAccess: async function (rsmCode) {
            await this.$store.dispatch("showOverlay", true);
            var result = await this.$store
                .dispatch("regionalSalesController/GetRSMAccess", rsmCode)
                .catch(async (error) => {
                    await this.$store.dispatch("showOverlay", false);
                    this.$toast.open({
                        message: error.data,
                        type: "error",
                    });
                });

            if (result) {
                await this.$store.dispatch("showOverlay", false);
                this.activeRsmCode = rsmCode;
                this.showSidebar = true;
            }
        },
        changeSidebarStatus: function (value) {
            this.showSidebar = value;
        },
        editRSMAccess: function (rsm) {
            this.rsmAccess.regionalSalesUserAccessID = rsm.regionalSalesUserAccessID;
            this.rsmAccess.rsmCode = rsm.rsmCode;
            this.rsmAccess.name = rsm.name;
            this.rsmAccess.email = rsm.email;
            this.listReportAccess = [];

            rsm.listReportAccess.forEach(access => {
                this.listReportAccess.push(this.reportAccessOption.filter(m => m.code == access)[0]);
            });

            this.isEditAccess = true;
            this.addRSMAccessModalShow = true;
        },
        AddRSMAccess: async function () {
            await this.$store.dispatch("showOverlay", true);
            this.rsmAccess.reportAccess = this.listReportAccess.map(m => m.code).join(';');
            var result = false;

            if (this.isEditAccess) {
                result = await this.$store
                    .dispatch("regionalSalesController/EditRSMAccess")
                    .catch(async (error) => {
                        await this.$store.dispatch("showOverlay", false);
                        this.$toast.open({
                            message: error.data,
                            type: "error",
                        });
                    });
            } else {
                result = await this.$store
                    .dispatch("regionalSalesController/AddRSMAccess")
                    .catch(async (error) => {
                        await this.$store.dispatch("showOverlay", false);
                        this.$toast.open({
                            message: error.data,
                            type: "error",
                        });
                    });
            }

            if (result) {
                await this.$store.dispatch("showOverlay", false);
                this.addRSMAccessModalShow = false;
                this.listReportAccess = [];

                var msg = this.isEditAccess ? 'updated' : 'added'
                this.$toast.open({
                    message: `RSM user access has been successfully ${msg}.`,
                    type: "success",
                });
            }
        },
        deleteRSMAccess: async function (email) {
            if (confirm("Are you sure you want to delete this RSM access?")) {
                await this.$store.dispatch("showOverlay", true);
                var result = await this.$store
                    .dispatch("regionalSalesController/DeleteRSMAccess", email)
                    .catch(async (error) => {
                        await this.$store.dispatch("showOverlay", false);
                        this.$toast.open({
                            message: error.data,
                            type: "error",
                        });
                    });

                if (result) {
                    await this.$store.dispatch("showOverlay", false);
                    this.$toast.open({
                        message: "RSM user access has been successfully deleted.",
                        type: "success",
                    });
                }
            }
        },
        resetRSMAccess: async function (email) {
            if (confirm("Are you sure you want to reset password?")) {
                await this.$store.dispatch("showOverlay", true);
                var result = await this.$store
                    .dispatch("regionalSalesController/ResetRSMAccess", email)
                    .catch(async (error) => {
                        await this.$store.dispatch("showOverlay", false);
                        this.$toast.open({
                            message: error.data,
                            type: "error",
                        });
                    });

                if (result) {
                    await this.$store.dispatch("showOverlay", false);
                    this.addRSMAccessModalShow = false;
                    this.$toast.open({
                        message: "RSM user access has been successfully reset.",
                        type: "success",
                    });
                }
            }
        },
        addNewRSM: async function () {
            this.isEdit = false;
            this.listEmail = [];
            this.listAgentCodes = [];

            await this.resetRegionalSalesManager();
            this.rsmModalShow = !this.rsmModalShow;
        },
        addEmailTag: function (email) {
            const tag = {
                name: email,
                code: email.substring(0, 2) + Math.floor(Math.random() * 10000000),
            };

            if (this.validateEmail(email)) {
                this.options.push(tag);
                this.listEmail.push(tag);
            } else {
                alert("Email format is not valid");
            }
        },
        removeTag: function (removedOption) {
            for (var i = 0; i < this.regionalSalesManager.listEmail.length; i++) {
                var obj = this.regionalSalesManager.listEmail[i];

                if (obj == removedOption.name) {
                    this.regionalSalesManager.listEmail.splice(i, 1);
                }
            }
        },
        deleteRSM: async function (rsm) {
            await this.setRegionalSalesManager(rsm);
            var self = this;
            self.$bvModal
                .msgBoxConfirm(
                    "Are you sure you want to delete " + rsm.rsmCode + "?",
                    {
                        title: "Delete RSM",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "YES",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        await self.$store.dispatch("showOverlay", true);

                        var result = await self.$store
                            .dispatch("regionalSalesController/DeleteRegionalSalesManager")
                            .catch(async (error) => {
                                await self.$store.dispatch("showOverlay", false);
                            });

                        if (result) {
                            await self.searchFilter();
                            await self.$store.dispatch("showOverlay", false);
                        }
                    }
                })
                .catch((err) => { });
        },
        paginationChanged: function (page) {
            if (page == null) {
                page = 1;
            }

            this.regionalSalesPageItems = this.regionalSales.slice(
                (page - 1) * this.pageSize,
                page * this.pageSize
            );
        },
        searchFilter: async function () {
            this.currentPage = 1;
            this.regionalSalesPageItems = [];
            this.isSearching = true;

            await this.$store
                .dispatch("territoryController/GetTerritories")
                .catch((error) => { });

            var result = await this.$store
                .dispatch("regionalSalesController/GetRegionalSales")
                .catch((error) => {
                    this.isSearching = false;
                });

            if (result) {
                this.paginationChanged(this.currentPage);
                this.isSearching = false;
            }
        },
        selectRSMAgent(rsm) {
            this.rsmCode = rsm.rsmCode
            this.rsmAgents = rsm.listAgentCodes
            this.rsmAgentsModalShow = true;
        },
        selectRSM: async function (rsm) {
            this.isEdit = true;
            this.listEmail = [];
            this.listAgentCodes = [];

            await this.setRegionalSalesManager(Object.assign({}, rsm));
            this.regionalSalesManager.listEmail.forEach((email) => {
                this.listEmail.push({
                    name: email,
                    code: email.substring(0, 2) + Math.floor(Math.random() * 10000000),
                });
            });
            this.regionalSalesManager.listAgentCodes.forEach((agentCode) => {
                this.listAgentCodes.push({
                    name: agentCode,
                    code: agentCode.substring(0, 2) + Math.floor(Math.random() * 10000000),
                });
            });

            this.rsmModalShow = true;
        },
        submitRegionalSalesManager: async function () {
            this.$v.regionalSalesManager.$touch();
            this.regionalSalesManager.listEmail = this.listEmail.reduce(
                (a, o) => (o.name && a.push(o.name), a),
                []
            );
            this.regionalSalesManager.listAgentCodes = this.listAgentCodes.reduce(
                (a, o) => (o.name && a.push(o.name), a),
                []
            );

            if (!this.$v.regionalSalesManager.$invalid) {
                await this.$store.dispatch("showOverlay", true);

                if (this.isEdit) {
                    var result = await this.$store
                        .dispatch("regionalSalesController/UpdateRegionalSalesManager")
                        .catch(async (error) => {
                            await this.$store.dispatch("showOverlay", false);
                        });

                    if (result) {
                        this.$v.regionalSalesManager.$reset();
                        await this.searchFilter();
                        this.rsmModalShow = false;
                        await this.$store.dispatch("showOverlay", false);
                    }
                } else {
                    var result = await this.$store
                        .dispatch("regionalSalesController/AddRegionalSalesManager")
                        .catch(async (error) => {
                            await this.$store.dispatch("showOverlay", false);
                        });

                    if (result) {
                        await this.searchFilter();
                        this.$v.regionalSalesManager.$reset();
                        this.rsmModalShow = false;
                        await this.$store.dispatch("showOverlay", false);
                    }
                }
            }
        },
        closeModal: async function () {
            await this.searchFilter();
            this.rsmModalShow = !this.rsmModalShow;
            this.$v.$reset();
        },
    },
    async mounted() {
        await this.searchFilter();
    },
};
</script>

<style></style>
